<template>
	<div>
		<!-- 地图容器 -->
		<div id="map"></div>

	</div>
</template>

<script>
	import {
		onMounted,
		reactive,
		ref,
		nextTick
	} from 'vue';
	import {
		init
	} from './init';
	export default {
		name: 'CDMap',
		props: {
			msg: String
		},
		setup() {
			//leaflet 对象实例
			const L_map = reactive({
				map: null,
				L: null
			});

			const iconUrl = ref('https://ysdtapi.cdssjj.changde.gov.cn/cdMapApi/profile/upload/2023/09/01/1_20230901113109A001.png');

			(function showMark() {
				
			})();

			//钩子函数  --------------------------------------------------------------------------
			onMounted(() => {
				const {
					map,
					L
				} = init();
				L_map.map = map;
				L_map.L = L;
				nextTick(() => {

				})
			})

			return {
				iconUrl,
			}
		}
	}
</script>

<style scoped>
	.hello {
		height: 100%;
		position: relative;
	}

	#map {
		height: 100vh;
	}
</style>